export default {
      //url : process.env.REACT_APP_FIREBASE_TEST_URL //tets
      url : process.env.REACT_APP_FIREBASE_PROD_URL //PROD
}